// Parser tolerante de texto colado para a importacao em lote. O backend
// (public.criar_lead_de_payload) so exige `empresa`; qualquer outro campo
// ausente ou malformado e descartado individualmente, entao o parser do
// front pode ser generoso — a validacao final e sempre do banco.

const CABECALHOS_CONHECIDOS: Record<string, string> = {
  empresa: "empresa",
  razao_social: "empresa",
  nome_empresa: "empresa",
  ramo: "ramo",
  segmento: "ramo",
  cidade: "cidade",
  municipio: "cidade",
  uf: "uf",
  estado: "uf",
  telefone: "telefone",
  tel: "telefone",
  celular: "telefone",
  whatsapp: "telefone",
  pessoa_contato: "pessoa_contato",
  contato: "pessoa_contato",
  responsavel: "pessoa_contato",
  email: "email",
  e_mail: "email",
  site: "site",
  website: "site",
  url: "site",
  prioridade: "prioridade",
  tags: "tags",
  etiquetas: "tags",
};

function normalizarCabecalho(raw: string): string {
  return raw
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_");
}

function detectarDelimitador(primeiraLinha: string): string {
  const candidatos = ["\t", ";", ","];
  let melhor = candidatos[0];
  let maiorContagem = -1;
  for (const c of candidatos) {
    const contagem = primeiraLinha.split(c).length;
    if (contagem > maiorContagem) {
      maiorContagem = contagem;
      melhor = c;
    }
  }
  return melhor;
}

export interface ImportParseResultado {
  linhas: Record<string, unknown>[];
  colunasReconhecidas: string[];
  colunasIgnoradas: string[];
  avisos: string[];
}

export function parseTextoColado(texto: string): ImportParseResultado {
  const linhasBrutas = texto
    .split(/\r\n|\n|\r/)
    .map((l) => l.trimEnd())
    .filter((l) => l.trim() !== "");

  if (linhasBrutas.length === 0) {
    return { linhas: [], colunasReconhecidas: [], colunasIgnoradas: [], avisos: ["Cole ao menos uma linha de cabeçalho e uma linha de dado."] };
  }

  const delimitador = detectarDelimitador(linhasBrutas[0]);
  const cabecalhosRaw = linhasBrutas[0].split(delimitador).map((h) => h.trim());
  const cabecalhosNormalizados = cabecalhosRaw.map(normalizarCabecalho);

  const colunasReconhecidas: string[] = [];
  const colunasIgnoradas: string[] = [];
  const mapaColuna: (string | null)[] = cabecalhosNormalizados.map((h) => {
    const chave = CABECALHOS_CONHECIDOS[h];
    if (chave) {
      colunasReconhecidas.push(cabecalhosRaw[cabecalhosNormalizados.indexOf(h)] ?? h);
      return chave;
    }
    colunasIgnoradas.push(h);
    return null;
  });

  const temEmpresa = mapaColuna.includes("empresa");
  const avisos: string[] = [];
  if (!temEmpresa) {
    avisos.push(
      'Nenhuma coluna reconhecida como "empresa" na primeira linha. Use uma ' +
        "primeira linha de cabeçalho com nomes como: empresa, ramo, cidade, uf, " +
        "telefone, pessoa_contato, email, site, prioridade, tags.",
    );
    return { linhas: [], colunasReconhecidas, colunasIgnoradas, avisos };
  }

  const linhas: Record<string, unknown>[] = [];
  for (let i = 1; i < linhasBrutas.length; i++) {
    const valores = linhasBrutas[i].split(delimitador).map((v) => v.trim());
    const linha: Record<string, unknown> = {};
    mapaColuna.forEach((chave, idx) => {
      if (!chave) return;
      const valor = valores[idx];
      if (valor === undefined || valor === "") return;
      if (chave === "tags") {
        linha.tags = valor
          .split(/[;,]/)
          .map((t) => t.trim())
          .filter(Boolean);
      } else {
        linha[chave] = valor;
      }
    });
    if (Object.keys(linha).length > 0) linhas.push(linha);
  }

  return { linhas, colunasReconhecidas, colunasIgnoradas, avisos };
}
